import { memo, useEffect } from 'react';
import { Navigate } from 'react-router';
import { InteractionManager } from 'react-native';
import { useSearchParams } from 'react-router-dom';
import { BottomSheet } from '@betty/navigation';

const WithdrawVerifyInteracEmailRedirect = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(
    () => () => {
      if (token) {
        InteractionManager.runAfterInteractions(() => {
          BottomSheet.open({
            namespace: 'wallet',
            type: 'WithdrawEmailVerification',
            data: { token },
          });
        });
      }
    },
    [token],
  );

  return <Navigate to="/" replace />;
};

export default memo(WithdrawVerifyInteracEmailRedirect);
